package team.platforma.dictionarydata.table

import kotlin.Long
import kotlin.String

public data class AiChapter(
  public val id: Long,
  public val name: String,
)
